/*
// Funzione per controllare se un elemento è un elemento "vino" in base all'ID
function isWineElement(element) {
  return element.id === 'tidio-chat-code'; // Assumendo che l'ID degli elementi "vino" sia 'vino'
}

// Funzione che verrà chiamata quando viene rilevato un cambiamento nel documento
function handleMutation(mutationsList, observer) {
  mutationsList.forEach(mutation => {
    mutation.addedNodes.forEach(addedNode => {
      // Verifica se l'elemento aggiunto è un elemento "vino"
      console.log(addedNode);
      if (isWineElement(addedNode)) {
        //alert("Nuovo elemento tidio aggiunto!");
        console.log("Nuovo elemento tidio aggiunto!");
      }
    });
  });
}

// Creare un nuovo MutationObserver
const observer = new MutationObserver(handleMutation);

// Configurazione dell'Observer per osservare i cambiamenti nel DOM
const config = { childList: true, subtree: true };

// Avviare l'osservazione del documento
observer.observe(document.body, config);
*/

function isMobileDevice() {
  // Controlla se la larghezza dello schermo è inferiore a 768 pixel (un comune breakpoint per dispositivi mobili)
  return window.innerWidth <= 768;
}

// Funzione che verifica se un nodo ha uno stile inline
function hasInlineStyle(node) {
  return node instanceof Element && node.hasAttribute("style");
}

// Funzione che verrà chiamata quando viene rilevato un cambiamento nel documento
function handleMutation(mutationsList, observer) {
  mutationsList.forEach(mutation => {
    mutation.addedNodes.forEach(addedNode => {
      // Verifica se l'elemento aggiunto è un div con ID "tidio-chat-code" e ha uno stile inline
      //console.log(addedNode);
      if (addedNode instanceof HTMLIFrameElement && addedNode.id === "tidio-chat-iframe" && hasInlineStyle(addedNode)) {
        // Chiama la funzione per monitorare le modifiche allo stile inline dell'iframe
        monitoraStileInlineIframe();

//        console.log("Stile inline aggiunto al div con ID 'tidio-chat-iframe'!");
//        console.log(addedNode.style);
//        console.log(addedNode.style.cssText);
        addedNode.style.cssText += "z-index: 28 !important;";
//        console.log(addedNode.style.cssText);
        if (isMobileDevice()) {
          //alert("Sito visualizzato su un dispositivo mobile!");
//          console.log("Sito visualizzato su un dispositivo mobile!");
          //addedNode.style.cssText += "inset: auto -7px 60px auto !important;";
          //addedNode.style.cssText += "bottom: 60px !important;";
          //addedNode.style.bottom = "60px";
          //addedNode.style.setProperty("inset", "auto -7px 60px auto", "important"); // Modifica il valore a quello desiderato, ad esempio "10px"
          //addedNode.style.setProperty("inset", "10px", "important"); // Modifica il valore a quello desiderato, ad esempio "10px"
          setTimeout(function() {
            //addedNode.style.setProperty("inset", "20px", "important");
            addedNode.style.cssText += "bottom: 60px !important;";
          }, 300);
        }
        //alert("Stile inline aggiunto al div con ID 'tidio-chat-code'!");
      }
    });
  });
}

// Creare un nuovo MutationObserver
const observer = new MutationObserver(handleMutation);

// Configurazione dell'Observer per osservare i cambiamenti nel DOM
const config = { attributes: true, attributeFilter: ["style"], childList: true, subtree: true };

// Avviare l'osservazione del documento
observer.observe(document.body, config);

function monitoraStileInlineIframe() {
  // Seleziona l'iframe con ID "tidio-chat-iframe"
  const iframe = document.getElementById("tidio-chat-iframe");

  // Verifica se l'iframe esiste
  if (!iframe) {
    console.error("Nessun iframe con ID 'tidio-chat-iframe' trovato.");
    return;
  }

  // Crea un nuovo MutationObserver
  const observer = new MutationObserver(function(mutationsList, observer) {
    // Itera attraverso le mutazioni rilevate
    mutationsList.forEach(mutation => {
      // Verifica se la mutazione riguarda l'attributo 'style' dell'iframe
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        // Mostra un alert quando lo stile inline dell'iframe viene modificato
        //alert("Lo stile inline dell'iframe con ID 'tidio-chat-iframe' è stato modificato!");
//        console.log("Lo stile inline dell'iframe con ID 'tidio-chat-iframe' è stato modificato!");
//        console.log(mutation.target.style.cssText);
//        console.log(mutation.target.style.inset);
        if (isMobileDevice()) {
//          console.log(mutation.target.style.getPropertyCSSValue("inset"));
//          console.log("Sito visualizzato su un dispositivo mobile!");
          if (mutation.target.style.inset == 'auto -7px 15px auto')
            mutation.target.style.cssText += "bottom: 60px !important;";
/*          setTimeout(function() {
//            mutation.target.style.cssText += "bottom: 60px !important;";
          }, 500); */
        }
      }
    });
  });

  // Configura l'observer per osservare le mutazioni dello stile inline dell'iframe
  observer.observe(iframe, { attributes: true, attributeFilter: ['style'] });
}

/* INIZIO - FREE SHIPPING BAR - CART DRAWER */

function getCartSubtotal() {
  // Seleziona l'elemento specifico usando querySelector
  const targetElement = document.querySelector('.drawer__contents > .drawer__inner > .drawer__scrollable > div[data-products] > div');

  // Verifica se l'elemento esiste
  if (targetElement) {
    // Leggi il valore dell'attributo data-cart-subtotal
    const subtotal = targetElement.getAttribute('data-cart-subtotal');

    // Stampa o restituisci il valore dell'attributo
    //console.log('Data Cart Subtotal:', subtotal);
    
    return subtotal;
  } else {
    console.error('Elemento target non trovato');
    return null;
  }
}

function addOrUpdateContainerFSB(subtotal) {
  // Seleziona l'elemento target usando querySelector
  const targetElement = document.querySelector('.drawer__contents > .drawer__inner > .drawer__scrollable');

  // Verifica se l'elemento target esiste
  if (targetElement) {
    // Controlla se esiste già un elemento con l'ID containerFSB-shi
    let existingElement = document.getElementById('containerFSB-shi');

    freeShippingBarHTML = generateFreeShippingBarHTML(subtotal, 'cart-drawer');
    
    if (existingElement) {
      // Aggiorna il contenuto del div esistente
      //existingElement.innerHTML = subtotal+'0'+Math.random();
      existingElement.innerHTML = freeShippingBarHTML;
    } else {
      // Aggiungi il nuovo div come primo figlio dell'elemento target
      //targetElement.insertAdjacentHTML('afterbegin', '<div id="containerFSB-shi">1</div>');
      targetElement.insertAdjacentHTML('afterbegin', '<div id="containerFSB-shi">' + freeShippingBarHTML + '</div>');
    }
  } else {
    console.error('Elemento target non trovato');
  }
}

function generateFreeShippingBarHTML(subtotal, type) {
    var barWidth = ( subtotal * 100 ) / 5900;
    var thresholdFS = 5900 - subtotal;
    if(type == 'cart-drawer')
      var freeShippingBarHTML = '<div class="miniCartFreeShippingMsg appear-animation appear-delay-2">';
    else
      var freeShippingBarHTML = '<div class="miniCartFreeShippingMsg">';
    if ( subtotal < 5900 ) {
      freeShippingBarHTML = freeShippingBarHTML + '<div id="shipping_progress_main"><div id="shipping_bar_inner" style="width:' + barWidth + '%;"></div></div>';
      freeShippingBarHTML = freeShippingBarHTML + '<div class="shipping-bar-msg ship_pending">Ti mancano <strong>' + theme.Currency.formatMoney(thresholdFS, theme.settings.moneyFormat) + '</strong> dalla spedizione gratuita!</div>'
    } else {
      freeShippingBarHTML = freeShippingBarHTML + '<div class="shipping-bar-msg ship_success">Congratulazioni, hai la spedizione gratuita!</div>';
    }
    freeShippingBarHTML = freeShippingBarHTML + '</div>';

  return freeShippingBarHTML;
}

// Seleziona l'elemento da osservare
const targetElement = document.querySelector('.drawer__footer > .cart__item-sub > div[data-subtotal]');

if (targetElement) {
  // Crea un'istanza di MutationObserver
  const observer = new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'subtree' || mutation.type === 'characterData') {
        //console.log('CIAO');
        subtotal = getCartSubtotal();
        if (subtotal !== null) {  
          addOrUpdateContainerFSB(subtotal);
        }

        break; // Interrompi il ciclo dopo aver mostrato l'alert
      }
    }
  });

  // Configura l'osservatore
  const config = { childList: true, subtree: true, characterData: true };

  // Avvia l'osservatore sull'elemento target
  observer.observe(targetElement, config);
} else {
  console.error('Elemento target non trovato');
}

/* FINE - FREE SHIPPING BAR - CART DRAWER */
/* INIZIO - FREE SHIPPING BAR - CART PAGE */

function getCartSubtotal1() {
  // Seleziona l'elemento specifico usando querySelector
  const targetElement = document.querySelector('#CartPageForm > .cart__page > .cart__page-col > div');

  // Verifica se l'elemento esiste
  if (targetElement) {
    // Leggi il valore dell'attributo data-cart-subtotal
    const subtotal = targetElement.getAttribute('data-cart-subtotal');

    // Stampa o restituisci il valore dell'attributo
    //console.log('Data Cart Subtotal:', subtotal);
    
    return subtotal;
  } else {
    console.error('Elemento target non trovato');
    return null;
  }
}


function UpdateCartContainerFSB(subtotal) {
    // Controlla se esiste già un elemento con l'ID containerFSB-cart-shi
    let existingElement = document.getElementById('containerFSB-cart-shi');

    freeShippingBarHTML = generateFreeShippingBarHTML(subtotal, 'cart');
    
    if (existingElement) {
      // Aggiorna il contenuto del div esistente
      existingElement.innerHTML = freeShippingBarHTML;
    } else {
    }
}

// Seleziona l'elemento da osservare
const targetElement1 = document.querySelector('#CartPageForm > .cart__page > .cart__page-col > .cart__item-sub > div[data-subtotal]');

if (targetElement1) {
  // Crea un'istanza di MutationObserver
  const observer = new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'subtree' || mutation.type === 'characterData') {
        //console.log('CIAO--');
        subtotal = getCartSubtotal1();
        UpdateCartContainerFSB(subtotal);
        break; // Interrompi il ciclo dopo aver mostrato l'alert
      }
    }
  });

  // Configura l'osservatore
  const config = { childList: true, subtree: true, characterData: true };

  // Avvia l'osservatore sull'elemento target
  observer.observe(targetElement1, config);
} else {
  console.error('Elemento target non trovato');
}

/* FINE - FREE SHIPPING BAR - CART PAGE */

/* inzio - HTML in countdown timer */
function replaceSpecialCharsInCountdown() {
  // Seleziona tutti gli elementi <p> con una classe che inizia con "countdown_timer_subheading"
  var elements = document.querySelectorAll('p[class^="countdown_timer_subheading"]');
  
  // Itera su ciascun elemento <p>
  elements.forEach(function(element) {
    // Sostituisce &lt; con < e &gt; con >
    var updatedText = element.innerHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    
    // Aggiorna il contenuto dell'elemento con il testo modificato
    element.innerHTML = updatedText;
  });
}

// Funzione per monitorare la creazione di un div con classe che inizia con "countdown_timer_wrapper"
function observeCountdownWrapperCreation() {
  // Seleziona il nodo radice (in questo caso l'intero documento)
  var targetNode = document.body;

  // Configura l'osservatore per rilevare solo aggiunte di nodi
  var observerOptions = {
    childList: true,  // osserva cambiamenti nei nodi figli
    subtree: true     // osserva anche i discendenti (non solo i figli diretti)
  };

  // Funzione di callback che verrà chiamata quando vengono rilevati cambiamenti nel DOM
  var observerCallback = function(mutationsList) {
    mutationsList.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          // Verifica se il nodo aggiunto è un <div> con una classe che inizia con "countdown_timer_wrapper"
          if (node.nodeType === 1 && node.matches('div[class^="countdown_timer_wrapper"]')) {
            // Attiva la funzione per sostituire i caratteri speciali
            replaceSpecialCharsInCountdown();
          }
        });
      }
    });
  };

  // Crea un nuovo osservatore e lo attacca al nodo target
  var observer = new MutationObserver(observerCallback);
  observer.observe(targetNode, observerOptions);
}

// Inizia l'osservazione della creazione del div con la classe "countdown_timer_wrapper"
observeCountdownWrapperCreation();
/* fine - HTML in countdown timer */

window.addEventListener("load", function () {
    const loveButtons = document.querySelectorAll("button.love-button");
console.log("loveButtons");
console.log(loveButtons);
    loveButtons.forEach(button => {
        // Attributi del button
console.log(button);
        button.setAttribute("aria-label", "Aggiungi questo prodotto ai preferiti");
        button.setAttribute("aria-pressed", "false");

        // Attributi degli SVG figli
        const svg = button.querySelector("svg");
        if (svg) {
            svg.setAttribute("aria-hidden", "true");
            svg.setAttribute("focusable", "false");
        }
    });
});